module.exports = __webpack_public_path__ + "media/roomBgm.feff3f0e.mp3";